import { render, staticRenderFns } from "./person-type-label.vue?vue&type=template&id=03c61998&scoped=true&"
import script from "./person-type-label.vue?vue&type=script&lang=js&"
export * from "./person-type-label.vue?vue&type=script&lang=js&"
import style0 from "./person-type-label.vue?vue&type=style&index=0&id=03c61998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c61998",
  null
  
)

export default component.exports